(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-article"]) return;
  try {
    
(() => {
  const initialize = (root) => {
    root.querySelectorAll('[data-journal-article]').forEach((article) => {
      if (article.dataset.journalReady) return;
      article.dataset.journalReady = 'true';
      const body = article.querySelector('.bb-reading__body');
      const contents = article.querySelector('[data-journal-contents]');
      const headings = Array.from(body.querySelectorAll('h2'));
      if (headings.length > 2) {
        const list = contents.querySelector('ol');
        headings.forEach((heading, index) => {
          if (!heading.id) heading.id = 'journal-section-' + index;
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = '#' + encodeURIComponent(heading.id);
          link.textContent = heading.textContent;
          item.append(link);
          list.append(item);
        });
        contents.hidden = false;
      }
      const kitPath = new URL(article.dataset.kitUrl, location.origin).pathname;
      body.querySelectorAll('ul').forEach((list) => {
        const links = Array.from(list.querySelectorAll('a'));
        if (links.length !== 3 || !links.every((link) => new URL(link.href).hostname === location.hostname && new URL(link.href).pathname.includes('/products/the-buff-bloom-'))) return;
        const local = links.find((link) => new URL(link.href).pathname === kitPath);
        if (!local) return;
        const primary = document.createElement('a');
        primary.className = 'bb-reading__shop';
        primary.href = article.dataset.kitUrl;
        primary.textContent = article.dataset.shopLabel;
        const details = document.createElement('details');
        details.className = 'bb-reading__regions';
        const summary = document.createElement('summary');
        summary.textContent = article.dataset.regionLabel;
        list.before(primary, details);
        details.append(summary, list);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-cart"]) return;
  try {
    
  document.querySelectorAll('.bb-cart-update').forEach(button => button.hidden = true);
  if (!customElements.get('bb-cart-quantity')) {
    customElements.define('bb-cart-quantity', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const input = this.querySelector('input');
        const minus = this.querySelector('[data-quantity-minus]');
        const plus = this.querySelector('[data-quantity-plus]');
        const form = input.form;
        const updateLimits = () => {
          minus.disabled = input.valueAsNumber <= Number(input.min);
          plus.disabled = input.max !== '' && input.valueAsNumber >= Number(input.max);
        };
        const save = () => {
          if (form.dataset.quantityUpdating || !form.reportValidity()) return;
          updateLimits();
          form.dataset.quantityUpdating = 'true';
          form.setAttribute('aria-busy', 'true');
          form.querySelectorAll('bb-cart-quantity button').forEach(button => button.disabled = true);
          form.requestSubmit(form.querySelector('button[name="update"]'));
        };
        minus.hidden = false;
        plus.hidden = false;
        updateLimits();
        minus.addEventListener('click', () => {
          if (form.dataset.quantityUpdating) return;
          input.stepDown();
          save();
        });
        plus.addEventListener('click', () => {
          if (form.dataset.quantityUpdating) return;
          input.stepUp();
          save();
        });
        input.addEventListener('change', save);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
